import $ from 'jquery';
import 'slick-carousel';
import { debounce } from '../utils/debounce';

const sliderServicesCard = () => {
	const el = {
		container: '.mi-card--services__container .elementor-loop-container',
	};

	const init = () => {
		$(function () {
			if (window.innerWidth < 601) exec();
			$(window).on(
				'resize',
				debounce(function () {
					if (window.innerWidth < 601) exec();
				}, 200),
			);
		});
	};

	const exec = () => {
		const $container = $(el.container);

		$container.find('style').prependTo($container.parent());

		$container.slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			arrows: true,
			prevArrow:
				'<button type="button" class="slick-prev"></button>',
			nextArrow:
				'<button type="button" class="slick-next"></button>',
			responsive: [
				{
					breakpoint: 601,
					settings: 'unslick',
				},
			],
		});
	};

	init();
};

try {
	sliderServicesCard();
} catch (error) {
	console.error(error);
}
